// extracted by mini-css-extract-plugin
export default {"cellCenter":"order_form_cellCenter__6lAbT"};